<div class="grid-x">
  <div class="cell small-12 minor-margin-bottom">
    Wells in the area of review will be stored as an array of values in the context of the map in the following format:
  </div>
  <div class="cell small-12 minor-margin-bottom">
    <ul>
      <li>API Number (as APINumber)</li>
      <li>Latitude (as latitude)</li>
      <li>Longitude (as longitude)</li>
      <li>Owner Name (as ownerName)</li>
      <li>Producing Formation (as producingFormation)</li>
      <li>Total Depth (as totalDepth)</li>
      <li>Well Name (as wellName)</li>
    </ul>
  </div>
</div>

<div class="grid-x">
  <div class="cell small-12 minor-margin-bottom">
    Context locations for well data defined earlier in the flow:
  </div>
  <div class="cell small-12 minor-margin-bottom">
    *For Latitude and Longitude, use X value for Longitude and Y value for Latitude.  If using Latitude and Longitude values that don't require conversion, do not provide a state plane location.
  </div>
</div>
@for (prop of componentData.config.wellDataPoints; track prop) {
  <div class="grid-x">
    <div class="cell small-5 small-font-size">
      {{prop.displayName}} :
    </div>
    <div class="cell small-7">
      <input type="text" [id]="prop.displayName" [(ngModel)]="prop.location" />
    </div>
  </div>
}
